// Reset popup cookie on language change
(function() {
  const currentLang = document.documentElement.lang;
  const storedLang = sessionStorage.getItem('popup_language');
  
  // If language changed, clear all cookies
  if (storedLang && storedLang !== currentLang) {
    const cookies = document.cookie.split(";");
    cookies.forEach(function(cookie) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });
    sessionStorage.clear();
    localStorage.clear();
  }
  
  sessionStorage.setItem('popup_language', currentLang);
})();
